export class FibuKonto {
    fibu_konto_id: number;
    konto_nr: string;
    bezeichnung: string;
    konto_typ: number;
    konto_typ_label: string;
    konto_art: string;
    bwa_gruppe_id: number;
    bwa_gruppe: string;
    sachkonto: string;
    kostenstelle_suffix: string;
    aktiv: number;
    kommentar: string;
    erstellt: Date;
    editiert: Date;
    mandant_id: number;
}

/** Anzeige-Labels für konto_typ (Aufwand/Ertrag/Bestand …) */
export const FIBU_KONTO_TYPEN: { value: number; label: string }[] = [
    { value: 1, label: 'Aufwand' },
    { value: 2, label: 'Ertrag' },
    { value: 3, label: 'Bestand' },
    { value: 4, label: 'Sonstig' },
    { value: 5, label: 'Kreditor' },
    { value: 6, label: 'Debitor' },
];

/** BWA-Gruppen – IDs müssen zu fibu_bwa_gruppen passen. */
export const FIBU_BWA_GRUPPEN: { bwa_gruppe_id: number; bezeichnung: string }[] = [
    { bwa_gruppe_id: 1, bezeichnung: 'Umsatzerlöse' },
    { bwa_gruppe_id: 2, bezeichnung: 'Wareneingang' },
    { bwa_gruppe_id: 3, bezeichnung: 'Sonstige betriebliche Erlöse' },
    { bwa_gruppe_id: 4, bezeichnung: 'Personalkosten' },
    { bwa_gruppe_id: 5, bezeichnung: 'Raumkosten' },
    { bwa_gruppe_id: 6, bezeichnung: 'Betriebliche Steuern' },
    { bwa_gruppe_id: 7, bezeichnung: 'Versicherungen / Beiträge' },
    { bwa_gruppe_id: 8, bezeichnung: 'Kfz-Kosten' },
    { bwa_gruppe_id: 9, bezeichnung: 'Werbe- / Reisekosten' },
    { bwa_gruppe_id: 10, bezeichnung: 'Kosten der Warenabgabe' },
    { bwa_gruppe_id: 11, bezeichnung: 'Abschreibungen' },
    { bwa_gruppe_id: 12, bezeichnung: 'Reparatur / Instandhaltung' },
    { bwa_gruppe_id: 13, bezeichnung: 'Steuern vom Einkommen und vom Ertrag' },
    { bwa_gruppe_id: 14, bezeichnung: 'Sonstige Kosten' },
    { bwa_gruppe_id: 15, bezeichnung: 'Zinsaufwand' },
    { bwa_gruppe_id: 16, bezeichnung: 'Sonstiger neutraler Aufwand' },
    { bwa_gruppe_id: 17, bezeichnung: 'Zinserträge' },
    { bwa_gruppe_id: 18, bezeichnung: 'Sonstige neutrale Erträge' },
];

const SONSTIGE_KOSTEN = new Set([
    4139, 4810, 4900, 4901, 4909, 4910, 4920, 4925, 4930, 4940, 4945, 4948, 4950, 4955, 4964, 4969, 4970, 4980, 4981, 4982,
]);
const REPARATUR = new Set([4800, 4801, 4805, 4806, 4807, 4809]);
const ABSCHREIBUNG = new Set([2406, 4822, 4830, 4832, 4855]);
const STEUERN_ERTRAG = new Set([2200, 2213, 2216, 4320]);
const ZINSAUFWAND = new Set([2110, 2120]);
const NEUTRALER_AUFWAND = new Set([2002, 2006, 2310, 2380, 2383, 8801]);
const ZINSERTRAEGE = new Set([2640, 2650, 2659]);
const NEUTRALE_ERTRAEGE = new Set([2315, 2700, 2742, 2749, 8820]);

function parseSachkontoNummer(kontoNr: string): number | null {
    const raw = (kontoNr || '').trim();
    if (!raw) {
        return null;
    }
    const stamm = raw.split('.')[0];
    const nr = Number.parseInt(stamm, 10);
    return Number.isFinite(nr) && nr > 0 ? nr : null;
}

/** Vorschlag aus Kontonummer (Sonderkonten vor Nummernkreis). */
export function suggestFibuBwaGruppeId(kontoNr: string): number | null {
    const nr = parseSachkontoNummer(kontoNr);
    if (nr == null) {
        return null;
    }
    if (SONSTIGE_KOSTEN.has(nr)) {
        return 14;
    }
    if (REPARATUR.has(nr)) {
        return 12;
    }
    if (ABSCHREIBUNG.has(nr)) {
        return 11;
    }
    if (STEUERN_ERTRAG.has(nr)) {
        return 13;
    }
    if (ZINSAUFWAND.has(nr)) {
        return 15;
    }
    if (NEUTRALER_AUFWAND.has(nr)) {
        return 16;
    }
    if (ZINSERTRAEGE.has(nr)) {
        return 17;
    }
    if (NEUTRALE_ERTRAEGE.has(nr)) {
        return 18;
    }
    if (nr >= 8600 && nr <= 8699) {
        return 3;
    }
    if (nr >= 8000 && nr <= 8999) {
        return 1;
    }
    if (nr >= 3000 && nr <= 3999) {
        return 2;
    }
    if (nr >= 4100 && nr <= 4199) {
        return 4;
    }
    if (nr >= 4200 && nr <= 4299) {
        return 5;
    }
    if (nr >= 4300 && nr <= 4399) {
        return 7;
    }
    if (nr === 4510) {
        return 6;
    }
    if (nr >= 4500 && nr <= 4599) {
        return 8;
    }
    if (nr >= 4600 && nr <= 4699) {
        return 9;
    }
    if (nr >= 4700 && nr <= 4799) {
        return 10;
    }
    return null;
}
